<div class="row g-3">
  @for (item of paginatedItems(); track trackItem(item, $index)) {
    <div [class]="colClass" class="d-flex paginated-list-col">
      <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
    </div>
  }
</div>

<app-paginator
  [currentPage]="currentPage()"
  [totalPages]="totalPages()"
  (pageChange)="onPageChange($event)">
</app-paginator>
